var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilesPlain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.8877C11.3812 13.8877 12.5 12.7689 12.5 11.3877C12.5 10.0064 11.3812 8.8877 10 8.8877C8.61875 8.8877 7.5 10.0064 7.5 11.3877C7.5 12.7689 8.61875 13.8877 10 13.8877ZM10 10.1377C10.6875 10.1377 11.25 10.7002 11.25 11.3877C11.25 12.0752 10.6875 12.6377 10 12.6377C9.3125 12.6377 8.75 12.0752 8.75 11.3877C8.75 10.7002 9.3125 10.1377 10 10.1377Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1.3877H5C4.3125 1.3877 3.75 1.9502 3.75 2.6377V17.6377C3.75 18.3252 4.3125 18.8877 5 18.8877H15C15.6875 18.8877 16.25 18.3252 16.25 17.6377V2.6377C16.25 1.9502 15.6875 1.3877 15 1.3877ZM12.5 17.6377H7.5V16.3877C7.5 16.0439 7.78125 15.7627 8.125 15.7627H11.875C12.2188 15.7627 12.5 16.0439 12.5 16.3877V17.6377ZM13.75 17.6377V16.3877C13.75 15.3502 12.9125 14.5127 11.875 14.5127H8.125C7.0875 14.5127 6.25 15.3502 6.25 16.3877V17.6377H5V2.6377H15V17.6377H13.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.8877H8.75V5.1377H11.25V3.8877Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.137695)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilesPlain);
export default __webpack_public_path__ + "static/media/profiles-plain.fd1676031f0206878f7bda3497f19d15.svg";
export { ForwardRef as ReactComponent };